// extracted by mini-css-extract-plugin
export default {"hide":"styles_hide__8hknI","greyed-out":"styles_greyed-out__JI2R5","centre":"styles_centre__4biV9","logo":"styles_logo__XmCiP"};